export const selectByArea = (state) => state.usageStats.byArea;
export const selectByUser = (state) => state.usageStats.byUser;
export const selectIsLoading = (state) => state.usageStats.isLoading;
export const selectError = (state) => state.usageStats.error;
export const selectFilters = (state) => state.usageStats.filters;

export const selectActivityEvents = (state) => state.usageStats.activityEvents;

export const selectActivityIsLoading = (state) =>
  state.usageStats.activityIsLoading;

export const selectActivityError = (state) => state.usageStats.activityError;

export const selectActivitySearch = (state) => state.usageStats.activitySearch;

export const selectActivityIsLoadingMore = (state) =>
  state.usageStats.activityIsLoadingMore;

export const selectActivitySort = (state) => state.usageStats.activitySort;

export const selectActivityHasMore = (state) => state.usageStats.activityHasMore;

export const selectActivityTotal = (state) => state.usageStats.activityTotal;

export const selectActivityFilteredTotal = (state) =>
  state.usageStats.activityFilteredTotal;
